<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import LayoutBase from '$lib/components/layouts/LayoutBase.svelte';
	import FooterPrimary from '$lib/components/FooterPrimary.svelte';
	import NavButtons from '$lib/components/layouts/NavButtons.svelte';
	import imageHeaderV5 from '$lib/assets/images/shared/yellow_banner_wave_v1_5x.svg';
	import imageHeaderV4 from '$lib/assets/images/shared/yellow_banner_wave_v1_4x.svg';
	import imageHeaderV3 from '$lib/assets/images/shared/yellow_banner_wave_v1_3x.svg';
	import imageHeaderV2 from '$lib/assets/images/shared/yellow_banner_wave_v1_2x.svg';
	import imageHeaderV1 from '$lib/assets/images/shared/yellow_banner_wave_v1_1x.svg';
	import imageHeaderWithMouseV4 from '$lib/assets/images/shared/header_yellow_mouse-v1-4x.png';
	import imageHeaderWithMouseV3 from '$lib/assets/images/shared/header_yellow_mouse-v1-3x.png';
	import imageHeaderWithMouseV2 from '$lib/assets/images/shared/header_yellow_mouse-v1-2x.png';
	import imageHeaderWithMouseV1 from '$lib/assets/images/shared/header_yellow_mouse-v1-1x.png';
	import imageHeaderWithMouseV2Large from '$lib/assets/images/shared/header_yellow_mouse-v2-2x.png';
	import imageHeaderWithKidsV4 from '$lib/assets/images/shared/header_yellow_kids-v2-4x.png';
	import imageHeaderWithKidsV3 from '$lib/assets/images/shared/header_yellow_kids-v2-3x.png';
	import imageHeaderWithKidsV2 from '$lib/assets/images/shared/header_yellow_kids-v2-2x.png';
	import imageHeaderWithKidsV1 from '$lib/assets/images/shared/header_yellow_kids-v1-1x.png';
	import imageHeaderWithMonstersV4 from '$lib/assets/images/shared/header_yellow_monsters-v1-4x.png';
	import imageHeaderWithMonstersV3 from '$lib/assets/images/shared/header_yellow_monsters-v1-3x.png';
	import imageHeaderWithMonstersV2 from '$lib/assets/images/shared/header_yellow_monsters-v1-2x.png';
	import imageHeaderWithMonstersV1 from '$lib/assets/images/shared/header_yellow_monsters-v2-1x.png';
	import imageGoBack from '$lib/assets/images/shared/go_back-v1-1x.png';

	export let primaryFooterContent = {};
	export let appLinks = false;
	export let socialLinks = false;
	export let headerClassList = 'relative w-full overflow-hidden 3xl:h-auto';
	export let contentClassList = 'flex flex-col items-center py-1';
	export let headerType = 'mouse';
	export let backButton = false;
	export let kidsafe = false;
	export let showLogin = false;
	export let showLogOut = false;
	export let showSignUp = false;
	export let margin = 0;

	const eventDispatcher = createEventDispatcher();

	function onBackClick() {
		eventDispatcher('click', {});
	}
</script>

<!-- // TODO: handle multiple images -->
<!-- // TODO: to handle sizing based on those images. -->
<LayoutBase {headerType} {margin}>
	<header class={`${headerClassList} ${headerType}`} slot="header">
		{#if kidsafe}
			<img
				id="graphic-kidsafe"
				src="//www.kidsafeseal.com/sealimage/1643675032741265067/abcmouse_medium_darktm.png"
				class={`absolute ${headerType}`}
				alt="kidsafe certified"
			/>
		{/if}
		{#if headerType === 'plain'}
			<picture>
				<source media="(min-width: 3000px)" srcset={imageHeaderV5} />
				<source media="(min-width: 2000px)" srcset={imageHeaderV4} />
				<source media="(min-width: 1440px)" srcset={imageHeaderV3} />
				<source media="(min-width: 1200px)" srcset={imageHeaderV2} />
				<img src={imageHeaderV1} alt="Yellow Banner" class="h-full w-screen object-cover" />
			</picture>
		{:else if headerType === 'mouse'}
			<picture>
				<source media="(min-width: 2000px)" srcset={imageHeaderWithMouseV4} />
				<source media="(min-width: 1440px)" srcset={imageHeaderWithMouseV3} />
				<source media="(min-width: 1200px)" srcset={imageHeaderWithMouseV2} />
				<img
					src={imageHeaderWithMouseV1}
					alt="Yellow Banner"
					class="h-full w-screen object-cover"
				/>
			</picture>
		{:else if headerType === 'mouse-small'}
			<picture>
				<source media="(min-width: 2000px)" srcset={imageHeaderWithMouseV2Large} />
				<source media="(min-width: 1440px)" srcset={imageHeaderWithMouseV2Large} />
				<source media="(min-width: 1200px)" srcset={imageHeaderWithMouseV2Large} />
				<img
					src={imageHeaderWithMouseV2Large}
					alt="Yellow Banner"
					class="h-full w-screen object-cover"
				/>
			</picture>
		{:else if headerType === 'kids'}
			<picture>
				<source media="(min-width: 2000px)" srcset={imageHeaderWithKidsV4} />
				<source media="(min-width: 1300px)" srcset={imageHeaderWithKidsV3} />
				<source media="(min-width: 1200px)" srcset={imageHeaderWithKidsV2} />
				<source media="(min-width: 620px)" srcset={imageHeaderWithKidsV2} />
				<img
					src={imageHeaderWithKidsV1}
					alt="Yellow Banner"
					class="h-auto w-full sm:object-cover"
				/>
			</picture>
		{:else}
			<picture>
				<source media="(min-width: 2000px)" srcset={imageHeaderWithMonstersV4} />
				<source media="(min-width: 1300px)" srcset={imageHeaderWithMonstersV3} />
				<source media="(min-width: 1200px)" srcset={imageHeaderWithMonstersV2} />
				<source media="(min-width: 620px)" srcset={imageHeaderWithMonstersV2} />
				<img
					src={imageHeaderWithMonstersV1}
					alt="Yellow Banner"
					class="h-auto w-full sm:object-cover"
				/>
			</picture>
		{/if}
		{#if backButton}
			<button id="btn-back" type="button" on:click|preventDefault={onBackClick}>
				<img
					src={imageGoBack}
					alt="Go Back"
					class="absolute left-[8%] top-[5%] z-40 h-auto w-[1rem]"
				/>
			</button>
		{/if}
		<NavButtons {showLogin} {showLogOut} {showSignUp} />
	</header>

	<!-- Main Content -->
	<main class={contentClassList} slot="content">
		<slot></slot>
	</main>

	<FooterPrimary slot="footer" content={primaryFooterContent} />
</LayoutBase>

<style>
	header {
		@apply lg:h-auto;
	}
	header.plain {
		@apply h-[8.5rem];
		@apply sm:h-[11.6rem];
		@apply md:h-[16rem];
		@apply lg:h-[18rem];
	}
	header.mouse {
		@apply h-[18rem];
	}
	header.mouse-small {
		@apply h-[7.5rem];
		@apply sm:h-[16rem];
	}
	header.kids {
		@apply md-classic:h-[18rem];
	}
	header.monsters {
		@apply sm:h-[18rem];
	}
	#graphic-kidsafe {
		@apply left-[2rem] top-[3rem] h-auto w-[9rem];
		@apply sm:top-[6rem] sm:w-[10rem];
		@apply md:left-[4rem] md:top-[10rem] md:w-[13rem];
		@apply lg:left-[calc(25%-29rem)];
	}
	#graphic-kidsafe.mouse {
		@apply top-[13.5rem];
	}
	#graphic-kidsafe.mouse-small {
		@apply top-[5.5rem];
		@apply w-[5rem];
		@apply sm:top-[12rem] sm:w-[7rem];
		@apply md:top-[12rem] md:w-[11rem];
	}
</style>
